import ProductReviewList from './ProductReviewList';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import mapProps from 'recompose/mapProps';
import withHandlers from 'recompose/withHandlers';
import formatPrismicData from '../../hocs/formatPrismicData';
import scrollTo from '../../utils/scrollTo';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import { withModel } from '../../data-providers/model';
import { trackCreateBookCTA } from '../../../analytics/category/product.js';

const handleClick = (href, countryModel) => () => {
  if (!href.startsWith('/')) {
    trackCreateBookCTA();
    scrollTo(href);
  } else {
    trackCreateBookCTA().then(() => {
      window.location = localiseUrl(countryModel, href);
    });
  }
};

const enhance = compose(
  withModel,
  formatPrismicData,
  withState('currentReviewIndex', 'setReviewIndex', 0),
  mapProps(({ model, ...props }) => ({
    countryModel: model.countryModel,
    trustPilotScore: model.prismicGlobalContentModel.general.trustpilot,
    ...props,
  })),
  withHandlers({
    updateReviewIndex: ({
      currentReviewIndex,
      setReviewIndex,
    }) => index => () => {
      if (currentReviewIndex !== index) {
        setReviewIndex(index);
      }
    },
    handleClick: ({ href, countryModel }) => handleClick(href, countryModel),
  }),
);

export default enhance(ProductReviewList);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductReviewList/index.js